/* global window */
import { Action } from './actions';
import { LoginStatus } from '../components/auth';

const defaultState = {
  status: LoginStatus.LoggedOut,
};

export default function (authState = defaultState, action) {
  const { status, account_id: aid } = authState;
  const { error, body } = action.payload || {};

  switch (action.type) {
    case Action.Auth.LoginCompleted:
      // eslint-disable-next-line camelcase
      if (!error && !aid) {
        return {
          account_id: body.account_id,
          as: body.identifier,
          groups: body.groups,
        };
      } if (error) {
        if (status !== LoginStatus.Failed || authState.failure !== body.error) {
          return {
            status: LoginStatus.Failed,
            failure: body.error.message,
          };
        }
      }
      break;
    case Action.Auth.LoginPending:
      if (authState.status !== LoginStatus.InProgress) {
        return { status: LoginStatus.InProgress };
      }
      break;
    case Action.Auth.LoggedOut:
      if (authState.status !== LoginStatus.LoggedOut) {
        if (window) {
          window.location = '/';
        }
        // Otherwise we're server side, what to do?
        return { status: LoginStatus.LoggedOut };
      }
      break;
    default:
      break;
  }
  return authState;
}
